import { exportIntakes } from '../services/api';
import { downloadResponseAsFile } from './downloadFile';
import type { IntakeFilters } from '../hooks/useIntake';

export async function downloadIntakeExport(
  filters: IntakeFilters
): Promise<void> {
  const response = await exportIntakes({
    query: {
      search: filters.search || undefined,
      start_date: filters.startDate || undefined,
      end_date: filters.endDate || undefined,
      intake_status: filters.statuses,
      clinic_id: filters.clinicId || undefined,
      assignee_ids: filters.assigneeIds,
      include_unassigned: filters.assigneeIncludeUnassigned || undefined,
      sort_by: filters.sortBy,
      sort_order: filters.sortOrder,
    },
    responseType: 'blob',
  });

  if (response.error) {
    throw new Error('Export failed');
  }

  downloadResponseAsFile(response, 'RogerIntakeExport.xlsx');
}
